<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}
        </div>
        <div class="list-content">
          <log-list-component :logType="'logDaily'" :dateKey="dateKey"></log-list-component>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>
import LogListComponent from "@/components/log/LogListComponent.vue";
export default {
  name: "Log",
  mixins: [],
  components: { LogListComponent},
  provide() {
    return {};
  },
  props: {},
  data() {
    return {
      dateKey:this.$route.params.date,
    };
  },
  created() {
    console.log("BAFAFASDFSADF")
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
  },
  watch: {},
};
</script>
